import { withStyles } from '@material-ui/styles';
import styles from './styles';
import Switch from './Switch';

export default withStyles(styles)(Switch);
